import { render, staticRenderFns } from "./GerenciarPerfis.vue?vue&type=template&id=00977ab0&scoped=true"
import script from "./GerenciarPerfis.vue?vue&type=script&lang=js"
export * from "./GerenciarPerfis.vue?vue&type=script&lang=js"
import style0 from "./GerenciarPerfis.vue?vue&type=style&index=0&id=00977ab0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00977ab0",
  null
  
)

export default component.exports